var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDzinho(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 43,
    viewBox: "0 0 74 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Illustra Dzinho"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tag Vazada (cor livre)",
    d: "M11.52 14H1.59199C0.713009 14 0 14.7483 0 15.6709V34.3291C0 35.2522 0.713009 36 1.59199 36H11.5195C17.3078 36 22 31.0752 22 25C22.0005 18.9248 17.3083 14 11.52 14ZM15.3568 26.2867C14.6242 26.2867 14.0305 25.6636 14.0305 24.8947C14.0305 24.1259 14.6242 23.5028 15.3568 23.5028C16.0893 23.5028 16.683 24.1259 16.683 24.8947C16.683 25.6636 16.0893 26.2867 15.3568 26.2867Z",
    fill: "#EB2FAB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tag Vazada (cor livre)_2",
    d: "M37.52 0H27.592C26.713 0 26 0.782365 26 1.74684V21.2532C26 22.2182 26.713 23 27.592 23H37.5195C43.3078 23 48 17.8514 48 11.5C48.0005 5.14865 43.3083 0 37.52 0ZM41.3568 12.8452C40.6242 12.8452 40.0305 12.1938 40.0305 11.39C40.0305 10.5861 40.6242 9.93472 41.3568 9.93472C42.0893 9.93472 42.683 10.5861 42.683 11.39C42.683 12.1938 42.0893 12.8452 41.3568 12.8452Z",
    fill: "#35ACE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tag Vazada (cor livre)_3",
    d: "M63.52 21H53.592C52.713 21 52 21.7483 52 22.6709V41.3291C52 42.2522 52.713 43 53.592 43H63.5195C69.3078 43 74 38.0752 74 32C74.0005 25.9248 69.3083 21 63.52 21ZM67.3568 33.2867C66.6242 33.2867 66.0305 32.6636 66.0305 31.8947C66.0305 31.1259 66.6242 30.5028 67.3568 30.5028C68.0893 30.5028 68.683 31.1259 68.683 31.8947C68.683 32.6636 68.0893 33.2867 67.3568 33.2867Z",
    fill: "#F2AA1A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDzinho);
export default __webpack_public_path__ + "static/media/dzinho.9c3baecbd9b5390a86954f046cd7c328.svg";
export { ForwardRef as ReactComponent };